import React from 'react';
import { useSelector } from 'react-redux';
import { useSitemap, useLabels, usePrefs } from 'wsm-common-data';
import { getVehicleParams } from '../utils/getVehicleParams';
import { getVehicleName } from '../utils/getVehicleName';
import { VEHICLE_DATA, LINE_BREAK_PLACEHOLDER } from '../constants/global';
import InventoryIcon from './InventoryIcon';

const InventoryLink = () => {
	const sitemap = useSitemap();
	const labels = useLabels();
	const { linkStyle, linkLabel, linkIcon, vehicleName, linkIconPlacement } =
		usePrefs();
	const { vehicleData } = useSelector((state) => state);

	const vehicleParams = getVehicleParams(VEHICLE_DATA, vehicleData);
	const name = getVehicleName(vehicleName, vehicleData);
	const queryString = `?${vehicleParams}`;
	const showInventoryIconBefore =
		linkIcon.length > 0 && linkIconPlacement === 'before';
	const showInventoryIconAfter =
		linkIcon.length > 0 && linkIconPlacement === 'after';

	return (
		<a
			className={`btn ${linkStyle}`}
			href={`${sitemap.get(
				'INVENTORY_LISTING_DEFAULT_AUTO_NEW'
			)}${queryString}`}
		>
			{showInventoryIconBefore && <InventoryIcon />}
			{labels.get(linkLabel)}
			<span className="sr-only">{`: ${labels
				.get('VEHICLE_NAME_PLACEHOLDER_INVENTORY')
				.replace(
					'{{vehicle name}}',
					name.replace(LINE_BREAK_PLACEHOLDER, '')
				)
				.trim()}`}</span>
			{showInventoryIconAfter && <InventoryIcon />}
		</a>
	);
};

export default InventoryLink;
